import moment from 'moment';

/**
 * Returns a moment object in local time, even if input is UTC/GMT
 * @param {string} date - The date string to convert
 * @returns {moment.Moment} - The moment object in local time
 */
export default function momentLocal(date) {
  return moment(date || null);
}
